<template>
  <div style="height: 100%">
    <div class="mb-5">
      <div class="flex justify-between">
        <div>
          <vs-button 
            @click="changeIframeUrl('/')" 
            :disabled="iframeLoading"
          >
            Tela Inicial
          </vs-button>

          <vs-button
            @click="changeIframeUrl('/categorias/geral')"
            :disabled="iframeLoading"
            class="ml-3"
          >
            Página da Categoria
          </vs-button>

          <vs-button 
            @click="changeIframeUrl(newsUrl)" 
            :disabled="iframeLoading" 
            class="ml-3"
          >
            Página da Notícia
          </vs-button>
        </div>

        <div>
          <div class="device-buttons-wp">
            <vs-button 
              color="primary"
              @click="selectedDevice = 'desktop'"
              type="flat" 
              icon="laptop_windows"
              size="small"
              class="mr-3 device-button"
            >
              Computador
            </vs-button>

            <vs-button 
              color="primary"
              @click="selectedDevice = 'mobile'"
              type="flat" 
              icon="stay_current_portrait"
              size="small"
              class="device-button"
            >
              Celular
            </vs-button>
          </div>

          <p>* Algumas campanhas mudam de lugar dependendo do dispositivo</p>
        </div>
      </div>
    </div>

    <div id="div-with-loading" class="vs-con-loading__container">
      <iframe
        id="iframecontainer"
        ref="iframecontainer"
        :src="`${iframeUrl}?chooseBanner=yes&userId=${userId}&chosenBannerPosition=${chosenBanner.position}`"
        :width="`${selectedDevice === 'desktop' ? '100%' : '414px'}`"
        height="100%"
      />
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  data() {
    return {
      siteUrl: process.env.VUE_APP_SITE_URL,
      iframeUrl: process.env.VUE_APP_SITE_URL,
      iframeLoading: false,
      selectedDevice: 'desktop',
    }
  },
  watch: {
    iframeUrl: function() {
      this.iframeLoading = true

      const that = this

      that.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })

      $('#iframecontainer').on('load', function() {
        that.iframeLoading = false
        that.$vs.loading.close('#div-with-loading > .con-vs-loading')
      })
    },
    'chosenBanner.position': function() {
      if (this.chosenBanner.hasBanner === true) {
        this.$vs.dialog({
          type:'confirm',
          acceptText: 'Sim',
          cancelText: 'Não',
          color: 'danger',
          title: `Atenção!`,
          text: 'Já existe um banner de campanha na posição escolhida. Deseja substituí-lo?',
          accept: () => {},
          cancel: this.cancelAlert
        })
      }

      // (não são tão importantes)
      // TODO: TENTAR colocar a dimensão da div no hover
      // TODO: Colocar o máximo de width x height pelo tamanho da div
    }
  },
  computed: {
    userId() {
      return this.$store.state.AppActiveUser.id
    },
    chosenBanner() {
      return this.$store.state.campaignBanners.chosenBanner
    },
    newsUrl() {
      const { lastNews } = this.$store.state.campaignBanners
      return `/${lastNews.category.slug}/noticia/${lastNews.id}/
        ${lastNews.created_at_sliced.year}/${lastNews.created_at_sliced.month}/
        ${lastNews.created_at_sliced.month}/${lastNews.slug}`
    }
  },
  methods: {
    changeIframeUrl(page) {
      this.iframeUrl = `${this.siteUrl}${page}`
    },
    cancelAlert() {
      this.$store.dispatch("campaignBanners/resetChosenBanner")
    }
  }
}
</script>

<style>
#div-with-loading {
  width: 100%;
  height: 100%;
}

.vs-popup--content {
  height: 100% !important;
  overflow: hidden !important;
}

.con-vs-dialog {
  z-index: 52099 !important;
}

.vs-dialog {
  z-index: 53000 !important;
}

.device-buttons-wp {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.device-button {
  font-size: 1em !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>